import React, { useState } from 'react';
import { Header } from '../components/layout/Header';
import { Sidebar } from '../components/layout/Sidebar';
import { Download } from 'lucide-react';
import { PnLSummaryCards } from '../components/analytics/PnLSummaryCards';
import { PnLChart } from '../components/analytics/PnLChart';
import { AssetPerformanceTable } from '../components/analytics/AssetPerformanceTable';
import { TradingActivityCharts } from '../components/analytics/TradingActivityCharts';
import { FuturesPnLSummary } from '../components/analytics/FuturesPnLSummary';
import { PnLCalendar } from '../components/analytics/PnLCalendar';
import { PositionPerformanceTable } from '../components/analytics/PositionPerformanceTable';
import { FuturesRiskMetrics } from '../components/analytics/FuturesRiskMetrics';
import { FundingRateChart } from '../components/analytics/FundingRateChart';
import { TradingEdgeCard } from '../components/analytics/TradingEdgeCard';
type TimeRange = '24H' | '7D' | '30D' | '90D' | '1Y' | 'ALL';
type TabType = 'overview' | 'futures';
export function AnalyticsPage() {
  const [timeRange, setTimeRange] = useState<TimeRange>('30D');
  const [activeTab, setActiveTab] = useState<TabType>('overview');
  const ranges: TimeRange[] = ['24H', '7D', '30D', '90D', '1Y', 'ALL'];
  const tabs: {
    id: TabType;
    label: string;
  }[] = [{
    id: 'overview',
    label: 'Overview'
  }, {
    id: 'futures',
    label: 'Futures Analytics'
  }];
  const handleExport = () => {
    console.log('Export analytics report');
  };
  return <div className="flex h-screen bg-background-primary text-text-primary overflow-hidden font-sans" data-id="element-2387">
      <Sidebar data-id="element-2388" />

      <div className="flex-1 flex flex-col min-w-0 mesh-bg" data-id="element-2389">
        <Header data-id="element-2390" />

        <main className="flex-1 overflow-y-auto relative z-0" data-id="element-2391">
          {/* Page Header */}
          <div className="border-b border-border-subtle" data-id="element-2392">
            <div className="px-6 py-4" data-id="element-2393">
              <div className="flex items-center justify-between mb-4" data-id="element-2394">
                <h1 className="text-2xl font-heading text-text-primary" data-id="element-2395">
                  Analytics
                </h1>

                <div className="flex items-center gap-4" data-id="element-2396">
                  {/* Time Range Selector */}
                  <div className="flex items-center gap-1 bg-background-elevated p-1 rounded-lg" data-id="element-2397">
                    {ranges.map(range => <button key={range} onClick={() => setTimeRange(range)} className={`px-3 py-1.5 text-xs font-medium rounded-md transition-all border ${timeRange === range ? 'bg-background-elevated text-text-primary border-border-default shadow-sm' : 'text-text-secondary border-transparent hover:text-text-primary hover:bg-white/5'}`} data-id="element-2398">
                        {range}
                      </button>)}
                  </div>

                  <button onClick={handleExport} className="flex items-center gap-2 px-4 py-2 bg-brand-purple/20 backdrop-blur-sm hover:bg-brand-purple/30 text-white rounded-xl transition-colors text-sm font-medium border border-[rgba(122,46,255,0.25)] border-t-[rgba(122,46,255,0.5)] hover:border-[rgba(122,46,255,0.35)] hover:border-t-[rgba(122,46,255,0.6)]" data-id="element-2399">
                    <Download size={16} data-id="element-2400" />
                    Export Report
                  </button>
                </div>
              </div>

              {/* Tabs */}
              <div className="flex items-center gap-1" data-id="element-2401">
                {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`px-4 py-1.5 text-sm font-ui rounded-lg transition-all ${activeTab === tab.id ? 'bg-background-elevated text-text-primary' : 'text-text-secondary hover:text-text-primary hover:bg-background-elevated/50'}`} data-id="element-2402">
                    {tab.label}
                  </button>)}
              </div>
            </div>
          </div>

          {/* Page Content */}
          <div className="p-6 space-y-6" data-id="element-2403">
            {activeTab === 'overview' ? <>
                <PnLSummaryCards data-id="element-2404" />
                <PnLChart timeRange={timeRange} data-id="element-2405" />
                <AssetPerformanceTable data-id="element-2406" />
                <TradingActivityCharts data-id="element-2407" />
              </> : <>
                <FuturesPnLSummary data-id="element-2408" />
                <FundingRateChart data-id="element-2409" />
                <TradingEdgeCard data-id="element-2410" />
                <PnLCalendar data-id="element-2411" />
                <PositionPerformanceTable data-id="element-2412" />
                <FuturesRiskMetrics data-id="element-2413" />
              </>}
          </div>
        </main>
      </div>
    </div>;
}